import { publishEvent, Constants } from '@salesforce/scv-connector-base';
import type { Call } from '@entities/call';
import type { ConnectedCallEventPublisher } from '@usecases/connected-call.usecase';
import { CallResultGenerator } from '@main/generators/call-result.generator';
import { Logger } from '@main/utils/logger';
import { CallTypes } from '@entities/call';
import { CallInfoGenerator } from '@main/generators/call-info.generator';
import type { CallType } from '@main/types/sf-types';

export class ConnectedCallPublisher implements ConnectedCallEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(
    call: Call,
    isRecordingPaused = true,
    recordEnabled = true,
  ): Promise<void> {
    const mapCallType = (type: CallTypes): CallType => {
      return type === CallTypes.INBOUND
        ? Constants.CALL_TYPE.INBOUND
        : Constants.CALL_TYPE.OUTBOUND;
    };

    const callResult = CallResultGenerator.generate(
      call.id,
      mapCallType(call.type),
      call.to,
    );

    callResult.call.state = Constants.CALL_STATE.CONNECTED;
    callResult.call.callInfo =
      CallInfoGenerator.generateWithRecordingCapabilities(
        call.id,
        isRecordingPaused,
        recordEnabled,
      );

    this.logger.info('Publisher: Connect call', {
      action: 'ConntecCall',
      ...call,
    });

    publishEvent({
      eventType: 'CALL_CONNECTED',
      payload: callResult,
      registerLog: false,
    });
  }
}
